<mat-form-field appearance="fill" class="flex flex-col flex-grow w-full">
  <mat-label>Search for product or scan barcode</mat-label>
  <input
    class="w-full"
    (keyup.enter.prevent)="attemptQuickAdd()"
    matInput
    data-cy="add-item-input"
    placeholder="Search or scan barcode"
    [formControl]="searchInput"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="handleOptionSelected($event)"
    [displayWith]="emptyDisplay"
  >
    <mat-option *ngFor="let option of searchResults | async" [value]="option">
      <p>{{ option.name }}</p>
      <p class="text-gray-500 text-sm">{{ option.formatted_identifiers }}</p>
    </mat-option>
    <mat-option [value]="FREE_TEXT_ITEM" testId="add-freetext-item">
      Add a freetext item
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
